import React from "react";
import { styled } from "@mui/material/styles";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import colors from "assets/theme-dark/base/colors";
import TruncatedText from "./TruncatedText";

interface SortButtonProps {
  column: string;
  label: string | JSX.Element;
  sortColumn: string;
  sortDirection: "asc" | "desc";
  handleSort: (column: string) => void;
  maxLength?: number;
}

const SortButton: React.FC<SortButtonProps> = ({
  column,
  label,
  sortColumn,
  sortDirection,
  handleSort,
  maxLength = 30,
}) => (
  <StyledSortButton onClick={() => handleSort(column)}>
    {typeof label === "string" ? <TruncatedText text={label} maxLength={maxLength} /> : label}
    {sortColumn === column &&
      (sortDirection === "asc" ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />)}
  </StyledSortButton>
);

const StyledSortButton = styled("button")(({ theme }) => ({
  background: "none",
  border: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(0.5),
  color: colors.text.primary,
  fontSize: "0.75rem",
  fontWeight: "bold",
  padding: theme.spacing(0.5),
  width: "100%",
  textAlign: "center",
}));

export default SortButton;
